import React, { useState, useEffect } from "react";

import SmallBusinessHeader from "./Header.jsx";
import SmallBusinessTable from "./Table.jsx";

import { getSmallBusinesses } from "../../../api/contractHolders.js";
import { removedBannedChs } from "../../../util/bannedChs.js";

import { SEARCH_TYPE_NAME } from "../../../constants.js";

/**
 * @typedef {import("../../../jsdoc/SmallBusiness.js").SmallBusiness} SmallBusiness
 */

/**
 * Adds a fullName field to the smallBusinesses data
 * @param {SmallBusiness[]} smallBusinesses
 * @returns {Object[]} smallBusinesses data with an added fullName attribute
 */
const addFullName = (smallBusinesses) =>
  smallBusinesses.map((smallBusiness) => ({
    ...smallBusiness,
    fullName: `${smallBusiness.companyName} (${smallBusiness.displayName})`,
  }));

export default function SmallBusiness({ setFetchError }) {
  // Init state
  const [smallBusinesses, setSmallBusinesses] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchType, setSearchType] = useState(SEARCH_TYPE_NAME);

  // Fetch Small Business data
  useEffect(() => {
    getSmallBusinesses()
      .then((smallBusinessData) => {
        setSmallBusinesses(addFullName(removedBannedChs(smallBusinessData)));
      })
      .catch((error) => {
        setFetchError(error);
      });
  }, []);

  let content;

  if (!smallBusinesses.length) {
    content = <div>Loading Small Businesses Data...</div>;
  } else {
    content = (
      <SmallBusinessTable smallBusinesses={smallBusinesses} searchValue={searchValue} searchType={searchType} />
    );
  }

  return (
    <div className="container-fluid" id="inner">
      <SmallBusinessHeader
        searchType={searchType}
        setSearchType={setSearchType}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      {content}
    </div>
  );
}
